import {
  AcctNoNin,
  UpgradeAccountRequest,
  UpgradeAccountTypes,
} from "../../types/upgradeAccount";
import CustomInputField from "../CustomInputField/CustomInputField";
import { initialAcctNoNinData, inputInfos } from "../../utils/constants";
import { useFormik } from "formik";
import { acctNoNinSchema } from "../../utils/validationSchemas";
import BtnSpinner from "../../assets/icons/BtnSpinner";
import apiHooks from "../../customHooks/apis";
import { useSearchParams } from "react-router-dom";
import OtpDialog from "../OtpDialog";
import { useEffect } from "react";
import { useAppDispatch } from "../../redux/hooks";
import { saveStepperData } from "../../redux/stepperSlice";

const AccountValidation: React.FC<Partial<UpgradeAccountTypes>> = ({
  setCurrentStep,
}) => {
  const { useUpgradeAccountValidation, useUserDetails } = apiHooks;
  const { clearUserDetails } = useUserDetails();
  const { handleValidateAccount, validatingAcct, isValidAcc, setIsValidAcc } =
    useUpgradeAccountValidation();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const tierType = +searchParams
    .get("type")
    ?.split("tier")[1] as UpgradeAccountRequest["tierType"];
  const updatedInitialAccData = { ...initialAcctNoNinData, tierType };
  const { handleChange, handleSubmit, values, isValid, errors } =
    useFormik<AcctNoNin>({
      initialValues: updatedInitialAccData,
      validationSchema: acctNoNinSchema,
      onSubmit(values) {
        handleValidateAccount({ ...values, tierType });
        dispatch(saveStepperData<AcctNoNin>(values));
      },
    });

  const isDisabledBtn = !isValid || validatingAcct;

  const handleCurrentStep = (step: number) => {
    if (step === 1) return setCurrentStep(step);
    setIsValidAcc(false);
  };

  useEffect(() => {
    clearUserDetails();
  }, []);

  if (isValidAcc)
    return <OtpDialog currentStep={0} setCurrentStep={handleCurrentStep} />;
  return (
    <form className="d-flex flex-column gap-4 p-4" onSubmit={handleSubmit}>
      <div className="d-flex flex-column">
        <h4 className="fw-semibold">
          Let’s Upgrade your account to enjoy maximum benefits
        </h4>
        <small className="text-secondary">
          Enter your Account Number to continue.
        </small>
      </div>
      <CustomInputField
        label="Account Number"
        placeholder="Enter your Account Number"
        value={values.accountNumber}
        onChange={handleChange}
        name="accountNumber"
        required
        errorMessage={errors.accountNumber}
      />
      <CustomInputField
        label="NIN"
        placeholder="Enter your NIN"
        value={values.nin}
        onChange={handleChange}
        required
        name="nin"
        errorMessage={errors.nin}
        info={inputInfos.nin}
      />
      <button
        className={`mt-auto  fw-semibold ms-auto coloredBtn ${isDisabledBtn ? "disabled" : ""}`}
        disabled={isDisabledBtn}
      >
        Validate {validatingAcct && <BtnSpinner />}
      </button>
    </form>
  );
};

export default AccountValidation;
